export const generatedListReadRouterNames = [
  "agency",
  "agencyMembership",
  "application",
  "applicationForm",
  "case",
  "caseTag",
  "cbcCheck",
  "employee",
  "hostFamilyProfile",
  "incentive",
  "lead",
  "placement",
  "studentRoster",
  "program",
  "programTemplate",
  "project",
  "reference",
  "referral",
  "school",
  "sevisAro",
  "sevisBatch",
  "sevisBatchItem",
  "team",
  "travel",
  "visaInterview",
  "waitlistEntry",
] as const;

export type GeneratedListReadRouterName = (typeof generatedListReadRouterNames)[number];

const generatedListReadRouterNameSet = new Set<string>(
  generatedListReadRouterNames,
);

export function isGeneratedListReadRouterName(
  value: string,
): value is GeneratedListReadRouterName {
  return generatedListReadRouterNameSet.has(value);
}

function getGeneratedListTrpcRouterName(
  procedurePath: string,
): GeneratedListReadRouterName | null {
  const [routerName, procedureName, ...extraPathParts] = procedurePath.split(".");

  return routerName !== undefined
      && isGeneratedListReadRouterName(routerName)
      && (procedureName === "list" || procedureName === "listComputed")
      && extraPathParts.length === 0
    ? routerName
    : null;
}

export function isGeneratedListTrpcProcedurePath(
  procedurePath: string,
): boolean {
  return getGeneratedListTrpcRouterName(procedurePath) !== null;
}

export function getGeneratedListTrpcEndpoint(procedurePath: string): string {
  const routerName = getGeneratedListTrpcRouterName(procedurePath);
  if (!routerName) {
    throw new Error(
      `Interactive generated-list request has no static transport: ${JSON.stringify(procedurePath)}.`,
    );
  }

  return `/api/trpc-list/${routerName}`;
}
